import { BybConditionalWrapper } from "@Components/common/byb-ds";
import { DialogSectionGrid } from "@Components/game/scenario-editor/styled-components";
import { Stack } from "@mui/material";
import DialogSection from "../dialog/dialog-section";
import { DialogSelectButton } from "../dialog/styled-components";
import { FilterItem } from "./types";

/**
 * This component is part of the VR app V2 redesign
 *
 * @param title The title
 * @param items Buttons to display
 * @param stack If `true`, the buttons will be displayed in a list instead of a grid
 * @param onClick Callback on button click
 */
interface IFilterDialogSection {
  title: string;
  items: FilterItem[];
  stack?: boolean;
  onClick: (index: number, selected?: boolean) => void;
}

const FilterDialogSection = ({ title, items, stack = false, onClick }: IFilterDialogSection) => {
  return (
    <DialogSection title={title}>
      <BybConditionalWrapper
        condition={stack}
        trueWrapper={(children) => <Stack spacing={2}>{children}</Stack>}
        falseWrapper={(children) => <DialogSectionGrid>{children}</DialogSectionGrid>}
      >
        {items.map((item, index) => (
          <DialogSelectButton key={index} variant={item.selected ? "contained" : "outlined"} onClick={() => onClick(index, item.selected)}>
            {item.label}
          </DialogSelectButton>
        ))}
      </BybConditionalWrapper>
    </DialogSection>
  );
};

export default FilterDialogSection;
